module.exports = __webpack_public_path__ + "img/84.10.pH.3b714fe9.png";